"use client";

import Image from "next/image";

export default function SolucoesContabeis({ data }) {
  const banner = data?.contentAttachments1?.map(item => {
    const hasImage = item?.attachFiles?.mediaCdnUrl || null;
    if(hasImage) {
      return {
        src: hasImage
      }
    }

    return false;
  }).filter(f => f !== false)[0] || [];


  const servicos = data?.contentAttachments2?.map((item, key) => {
    return {
      idx: key + 1,
      title: item.attachField1,
      description: item.attachField2
    }
  }).filter(f => f !== false) || [];

  return (
    <>
      <section className="relative w-full h-[500px] sm:h-[600px] md:h-[700px] overflow-hidden">
        <Image
          src={ banner.src }
          alt="Soluções Contábeis"
          fill
          className="object-cover"
          priority
        />
        <div className="absolute inset-0 bg-black/30" />
      </section>

      {/* Seção Azul */}
      <section className="w-full bg-blue-500 text-white py-16 px-4">
        <div className="w-full max-w-[1440px] mx-auto flex flex-col items-center text-center gap-10">
          {/* Título */}
          <h2 className="text-[32px] sm:text-[36px] md:text-[40px] font-bold">
            { data?.contentField1 }
          </h2>

          {/* Imagem Logos */}
          <img
            src="/assets/logos.png"
            alt="Logo da Empresa"
            className="w-[200px] sm:w-[250px] md:w-[300px]"
          />

          {/* Grade de Serviços */}
          <div className="w-full max-w-[1440px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-8 text-center md:text-left mb-12 mt-8">
            {servicos.map((item, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center md:items-start animate-on-scroll"
              >
                <h3 className="text-[70px] sm:text-[90px] md:text-[100px] font-thin mb-2 leading-none">
                  0{ item.idx }.
                </h3>
                <p className="text-[28px] sm:text-[35px] md:text-[40px] font-thin mb-4">
                  { item.title }
                </p>
                <div className="w-[80px] h-[5px] bg-white mb-4"></div>
                <ul className="text-[18px] sm:text-[20px] font-light space-y-1">
                  { item.description }
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
